module.exports = __webpack_public_path__ + "ireland.d3255f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/ireland.png
// module id = 1499
// module chunks = 0